import type { OTCDealData } from '@src/types/OTC';
import { AppwideDrawerContentType, useAppwideDrawerContext } from '@talos/kyoko';
import { useCallback, useState } from 'react';
import { InstrumentInspectorDrawer } from './InstrumentInspectorDrawer';

/** Drawer title for OTC derivatives (forwards, options, etc.) */
export const INSTRUMENT_INSPECTOR_DRAWER_TITLE = 'Instrument Details';

/** Drawer title for fixed / floating OTC loans */
export const LOAN_INSPECTOR_DRAWER_TITLE = 'Loan Details';

export const useInstrumentInspectorDrawer = () => {
  const { openDrawer, closeDrawer, isOpen: isInstrumentInspectorDrawerOpen } = useAppwideDrawerContext();
  const [currentInstrumentData, setCurrentInstrumentData] = useState<OTCDealData | undefined>(undefined);

  const openInstrumentInspectorDrawer = useCallback(
    (instrumentData: OTCDealData, title: string, onlyIfOpen?: boolean) => {
      if (onlyIfOpen && !isInstrumentInspectorDrawerOpen) {
        return;
      }

      setCurrentInstrumentData(instrumentData);

      openDrawer({
        type: AppwideDrawerContentType.InstrumentInspector,
        title,
        renderContent: () => <InstrumentInspectorDrawer instrumentData={instrumentData} />,
        drawerHeaderDesign: 'flex',
      });
    },
    [openDrawer, isInstrumentInspectorDrawerOpen]
  );

  const closeInstrumentInspectorDrawer = useCallback(() => {
    closeDrawer();
    setCurrentInstrumentData(undefined);
  }, [closeDrawer]);

  return {
    openInstrumentInspectorDrawer,
    closeInstrumentInspectorDrawer,
    isInstrumentInspectorDrawerOpen,
    currentInstrumentData,
  };
};
